import { create } from 'zustand';
import { persist } from 'zustand/middleware';

function syncDocumentClass(darkMode) {
  document.documentElement.classList.toggle('light', !darkMode);
}

export const useThemeStore = create(
  persist(
    (set, get) => ({
      darkMode: true,
      sidebarCollapsed: false,
      toggleDark: () => {
        const darkMode = !get().darkMode;
        syncDocumentClass(darkMode);
        set({ darkMode });
      },
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      applyToDocument: () => syncDocumentClass(get().darkMode),
    }),
    { name: 'arca-admin-theme' },
  ),
);
